// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CropperController from "./cropper_controller"
application.register("cropper", CropperController)

import FieldPresenceController from "./field_presence_controller"
application.register("field-presence", FieldPresenceController)

import MaskedFormController from "./masked_form_controller"
application.register("masked-form", MaskedFormController)

import PaymentInputsController from "./payment_inputs_controller"
application.register("payment-inputs", PaymentInputsController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PromoterToolsSubscriptionsController from "./promoter_tools_subscriptions_controller"
application.register("promoter-tools-subscriptions", PromoterToolsSubscriptionsController)

import PromotionChampionsController from "./promotion_champions_controller"
application.register("promotion-champions", PromotionChampionsController)

import ReloadFrameController from "./reload_frame_controller"
application.register("reload-frame", ReloadFrameController)

import ResendOtpCodeController from "./resend_otp_code_controller"
application.register("resend-otp-code", ResendOtpCodeController)

import SelectpickerController from "./selectpicker_controller"
application.register("selectpicker", SelectpickerController)

import TicketController from './ticket_controller'
application.register('ticket', TicketController)

import TicketsController from './tickets_controller'
application.register('tickets', TicketsController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import DestroyOnBlankController from "./destroy_on_blank_controller"
application.register("destroy-on-blank", DestroyOnBlankController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)
